import { inject, provide } from 'vue';

import type { TScrollObserver } from './components';
import type { ComputedRef, InjectionKey, Ref } from 'vue';

type TLayoutPart = {
  size: number;
  offset: number;
  space: boolean;
};

export interface ILayoutContextProps {
  instances: any;
  view: ComputedRef<string>;
  isContainer: ComputedRef<boolean>;
  rootRef: Ref<HTMLElement | undefined>;
  height: Ref<number>;
  containerHeight: Ref<number>;
  scrollbarWidth: Ref<number>;
  totalWidth: ComputedRef<number>;
  rows: ComputedRef<{
    top: string[];
    middle: string[];
    bottom: string[];
  }>;
  header: TLayoutPart;
  right: TLayoutPart;
  footer: TLayoutPart;
  left: TLayoutPart;
  scroll: Ref<TScrollObserver>;
  animate: () => void;
  update: (part: keyof ILayoutContextProps, prop: string, value: any) => void;
}

export const CdsLayoutSymbol: InjectionKey<ILayoutContextProps> = Symbol('cds:layout');

export const useProvideLayout = (props: ILayoutContextProps) => {
  provide(CdsLayoutSymbol, props);
};

export const useInjectLayout = () => {
  return inject(CdsLayoutSymbol, {} as ILayoutContextProps);
};
